import React from 'react';

import FakeProductListStats from "../../FakeProductListStats";
import EnrichmentActions from "./EnrichmentActions";
import EnrichmentTable from "./EnrichmentTable";

// TODO: temp, just for test in a new view
function Pim(props) {
    const enrichmentProduct = props.location?.state?.enrichmentProduct;
    return (
        <div style={{marginLeft: '240px', padding: '24px'}}>
            <FakeProductListStats total={12} />
            <EnrichmentActions selected={[]} list={() => {}} match={{}} />
            <EnrichmentTable enrichmentProduct={enrichmentProduct} />
        </div>
    );
}

export default Pim;
